// Tokens.js
import React, { useContext, useState, useEffect, useRef, useCallback } from "react";
import { TokenContext } from "./tokenContext"; // import TokenContext
import { useNavigate } from "react-router-dom";
import "./Purchase.css";
import { getAuth } from "firebase/auth";
import { db } from "../utils/firebase";
import {
  doc,
  getDoc,
  updateDoc,
} from "firebase/firestore";
import { logout } from "../utils/firebase";
import Spinner from "./Spinner";
import PricingCards from "./PricingCards.js";
import GlobalNavDrawer from "../components/GlobalNavDrawer";
import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe(process.env.REACT_APP_STP_REAL);
//const stripePromise = loadStripe(process.env.REACT_APP_STP_TST);

function Purchase() {
  const { balance } = useContext(TokenContext);
  const { purchaseIntent, setPurchaseIntent } = useContext(TokenContext);
  const [currentTokens, setCurrentTokens] = useState(0);
  const [selectedTokens, setSelectedTokens] = useState(purchaseIntent); // State for selected token amount
  const navigate = useNavigate();
  console.log("selectedTokens: ", selectedTokens);
  const [isPurchasing, setIsPurchasing] = useState(false);
  const tokensRef = useRef(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const scrollToTokens = useCallback(() => {
  const el = tokensRef.current || document.getElementById("tokens-section");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    else window.location.hash = "#tokens-section";
  }, []);

  const goAway = () => {
    navigate("/menu");
  };
  console.log(stripePromise);
  useEffect(() => {
    const fetchTokens = async () => {
      const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        const userRef = doc(db, "users", user.uid);
        try {
          const userDoc = await getDoc(userRef);
          if (userDoc.exists()) {
            setCurrentTokens(userDoc.data().tokens || 0);
          }
        } catch (error) {
          console.error("Error fetching token count: ", error);
        }
      }
    };

    fetchTokens();
  }, [currentTokens, setCurrentTokens]);

  useEffect(() => {
    (async () => {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) return;

      const snap = await getDoc(doc(db, "users", user.uid));
      const d = snap.exists() ? snap.data() : {};
      // handle a few common shapes
      setIsAdmin(Boolean(
        d.isAdmin || d.role === "admin" || d.roles?.admin
      ));
    })();
  }, []);

  const handleTokenPurchase = async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    setIsPurchasing(true);
    setPurchaseIntent(Number(selectedTokens) || 0);
    if (user) {
      const userRef = doc(db, "users", user.uid);
      try {
        const stripe = await stripePromise;
        try {
          console.log("SelectedTokens: ", selectedTokens);
          const response = await fetch(
            "https://fluency.ispeakwell.ca/api/create-checkout-session",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ quantity: selectedTokens,
                                     frontendOrigin: window.location.origin }),
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const data = await response.json();
          console.log("Session data:", data);

          if (data.sessionId) {
            await updateDoc(userRef, {
              desiredPurchase: parseInt(selectedTokens, 10),
              paying: true,
              checkoutSessionId: data.sessionId,
          });
            const result = await stripe.redirectToCheckout({
              sessionId: data.sessionId,
            });

            if (result.error) {
              console.log(result.error.message);
            }
          } else {
            console.log("No session ID returned from the server");
          }
        } catch (error) {
          console.error("Error in handleTokenPurchase:", error.message);
        }
      } catch (error) {
        console.error("Error setting desiredPurchase:", error);
      }
    }
  };

  const navigateTo = (path) => {
    navigate(path);
  };

  const showPurchaseHistory = () => {
    navigate("/purchasehistory");
  };

  return (
    <div className="PCH-Purchase-container">
      <h1 className="PCH-header-title">The iSpeakWell Project</h1>

    <h5 className="PCH-tagline">
      {isAdmin
        ? "Purchase tokens to run your room."
        : "Become a member of the iSpeakWell crew."
      }
    </h5>

    {!isAdmin && (
      <PricingCards onGotoTokens={scrollToTokens} />
    )}

    <div ref={tokensRef} id="tokens-section"></div>

    {!isAdmin ? (
      <>
        <h1>OR</h1>
        <h1>Just Purchase Tokens</h1>
      </>
    ) : (
      <h1>Purchase Tokens</h1>
    )}


      <h2>You currently have {currentTokens} tokens.</h2>
      <input
        className="PCH-TokenNum"
        type="number"
        value={selectedTokens}
        onChange={(e) => setSelectedTokens(e.target.value)}
        min="0"
        max="50"
      />

      {isPurchasing ? (
        <Spinner />
      ) : (
        <div className="ButtonstoNav">
          <button onClick={handleTokenPurchase}>Purchase Tokens</button>
          <button onClick={showPurchaseHistory}>Purchase History</button>
          <button className="PCH-menuGoer" onClick={goAway}>
            Menu
          </button>
        </div>
      )}

      <h2 className="PCH-token-header">What Are Tokens For?</h2>
      <p className="PCH-token-description">
        Tokens unlock premium tools to boost your communication, confidence, and career readiness.
      </p>

      <div className="PCH-token-grid">
        <div className="PCH-token-card">AI Speaking Partner<br /><span>(1 Token - 25 Turns)</span></div>
        <div className="PCH-token-card">AI Resume Revision, Keyword Analysis, Suggested Career Path, & Cover Letter Generation<br /><span>(1 Token)</span></div>
        <div className="PCH-token-card">AI Interview Assessment<br /><span>(1 Token - 5 Questions & Response Analysis)</span></div>
        <div className="PCH-token-card">AI-Prompted Speaking Plan<br /><span>(1 Token)</span></div>
        <div className="PCH-token-card">AI Coached Professional Conversation Partner<br /><span>(1 Token - 25 Turns)</span></div>
        <div className="PCH-token-card">Create a Private Training Room<br /><span>(10 Tokens)</span></div>
        <div className="PCH-token-card">Join a Private Training Room<br /><span>(2 Tokens)</span></div>
        <div className="PCH-token-card">
          <div>Why buy tokens?</div>
          <hr></hr>
          <span>For users who want to precisely control their spend!</span>
          <span>(Best Value)</span>
        </div>
      </div>

      <GlobalNavDrawer
          hideCurrent
            links={[
              {label: `Tokens: ${balance}`},
              { to: "/voicebot", label: "iSpeakWell" },
              { to: "/resumerevisor", label: "Resumes" },
              { to: "/conversationpractice", label: "Convos" },
              { to: "/interview-practice", label: "Interviews" },
              { to: "/termsofservice", label: "Terms" },
              { to: "/privacypolicy", label: "Privacy" },
              { to: "/admin", label: "Admin" },
              { to: "/login", label: "Logout", onClick: async () => { await logout(); } },
            ]}
              />
      <div className="PCH-links-section">
        <button
          className="PCH-link-button"
          onClick={() => navigateTo("/about")}
        >
          About
        </button>
        <button
          className="PCH-link-button"
          onClick={() => navigateTo("/careers")}
        >
          Careers
        </button>
        <button
          className="PCH-link-button"
          onClick={() => navigateTo("/tokens")}
        >
          Tokens
        </button>
        <button
          className="PCH-link-button"
          onClick={() => navigateTo("/contactus")}
        >
          Contact Us
        </button>
        <button
          className="PCH-link-button"
          onClick={() => navigateTo("/login")}
        >
          Login
        </button>
      </div>
    </div>
  );
}
export default Purchase;
